import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { useIntl } from 'react-intl';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import messages from './messages';
import style from './style.module.less';
import { noop } from 'ui-components/default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';

const MappingsDropDown = ({ getMatchingCSVField, setMatchingCSVField, importedCols = emptyArray, ssField = '', onClick = noop }) => {
  const onClickCb = useCallback(() => onClick(ssField), [onClick, ssField]);
  const intl = useIntl();
  const mappingsDropdownDefaultOption = intl.formatMessage(messages.mappingsDropdownDefaultOption);
  return (
    <div className={style['mapping-dropdown-wrapper']} onClick={onClickCb}>
      <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth variant='form'>
        <DropdownMenuToggler>
          {(getMatchingCSVField(ssField) && getMatchingCSVField(ssField).name) || mappingsDropdownDefaultOption}
        </DropdownMenuToggler>
        <DropdownMenuItem onClick={() => setMatchingCSVField(ssField, '')}>{mappingsDropdownDefaultOption}</DropdownMenuItem>
        {importedCols.map(({ name, displayName }, i) => (
          <DropdownMenuItem key={i} onClick={() => setMatchingCSVField(ssField, name)}>
            {displayName}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

MappingsDropDown.propTypes = {
  getMatchingCSVField: PropTypes.func.isRequired,
  importedCols: PropTypes.arrayOf(
    PropTypes.shape({
      mappedToField: PropTypes.string,
      name: PropTypes.string,
      displayName: MessageDescriptorPropType,
    }),
  ),
  ssField: PropTypes.string,
  setMatchingCSVField: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default MappingsDropDown;
